import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import Reveal, { SectionHead } from "@/components/Reveal";

const images = [
  { src: "https://customer-assets-agu9un31.emergentagent.net/job_player-cristian-diaz/artifacts/17ih4pei_IMG_9418.jpeg", alt: "Díaz N°42 conduciendo en el Monumental", span: "sm:col-span-2 sm:row-span-2" },
  { src: "https://customer-assets-agu9un31.emergentagent.net/job_player-cristian-diaz/artifacts/y0ve7kzg_IMG_9415.jpeg", alt: "Pase largo ante la Garra Blanca", span: "" },
  { src: "https://customer-assets-agu9un31.emergentagent.net/job_player-cristian-diaz/artifacts/18x6kqrb_IMG_9416.jpeg", alt: "Ordenando al equipo", span: "" },
  { src: "https://customer-assets-agu9un31.emergentagent.net/job_player-cristian-diaz/artifacts/r0u3jubp_IMG_9420.jpeg", alt: "Con la Roja Sub-17", span: "sm:col-span-2" },
  { src: "https://customer-assets-agu9un31.emergentagent.net/job_player-cristian-diaz/artifacts/8a3sskms_IMG_9419.jpeg", alt: "Carrera con la Selección Chilena", span: "" },
  { src: "https://images.unsplash.com/photo-1706675780107-7c43cc487928?crop=entropy&cs=srgb&fm=jpg&q=85", alt: "Noche de estadio", span: "" },
];

export default function Galeria() {
  const [selected, setSelected] = useState(null);

  return (
    <section id="galeria" data-testid="galeria-section" className="relative py-28 px-6 border-t border-neutral-900">
      <div className="max-w-6xl mx-auto">
        <SectionHead eyebrow="04 — Galería" title="Momentos del Cacique" testId="galeria-title" />

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 sm:auto-rows-[240px] gap-4" data-testid="gallery-grid">
          {images.map((img, i) => (
            <Reveal key={img.src} delay={i * 0.05} className={`group relative overflow-hidden border border-neutral-800 cursor-pointer ${img.span}`}>
              <button
                type="button"
                data-testid={`gallery-item-${i}`}
                onClick={() => setSelected(i)}
                className="block w-full sm:h-full"
                aria-label={`Ampliar: ${img.alt}`}
              >
                <img
                  src={img.src}
                  alt={img.alt}
                  className="w-full h-auto sm:h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
                <span className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-[#050505]/90 to-transparent p-4 font-tech text-[10px] uppercase tracking-[0.25em] text-neutral-300 opacity-0 group-hover:opacity-100 transition-opacity text-left">
                  {img.alt}
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      <AnimatePresence>
        {selected !== null && (
          <motion.div
            data-testid="gallery-lightbox"
            className="fixed inset-0 z-[60] bg-black/90 backdrop-blur-md flex items-center justify-center p-6"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelected(null)}
          >
            <motion.img
              src={images[selected].src}
              alt={images[selected].alt}
              className="max-h-[85vh] max-w-full object-contain border border-neutral-800"
              initial={{ scale: 0.92, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.95, opacity: 0 }}
              transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
            />
            <button
              type="button"
              data-testid="gallery-lightbox-close"
              onClick={() => setSelected(null)}
              className="absolute top-6 right-6 text-neutral-400 hover:text-[#d4af37] transition-colors"
              aria-label="Cerrar"
            >
              <X size={32} />
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
